import { faAngleLeft, faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect } from 'react'
import { Link } from 'react-router-dom';
import Slider from 'react-slick/lib/slider';
import AOS from 'aos';
import 'aos/dist/aos.css';
const Genres = ({ genres }) => {
    const CustomNextArrow = ({ onClick }) => (
        <button className="custom-next-arrow" onClick={onClick}>
            <FontAwesomeIcon aria-hidden="true" icon={faAngleRight} />
        </button>
    );
    const CustomPrevArrow = ({ onClick }) => (
        <button className="custom-prev-arrow" onClick={onClick}>
            <FontAwesomeIcon aria-hidden="true" icon={faAngleLeft} />
        </button>
    );
    /*   const settings = {
          dots: false,
          infinite: true,
          speed: 500,
          slidesToShow: 8,
          slidesToScroll: 1,
          nextArrow: <CustomNextArrow />,
          prevArrow: <CustomPrevArrow />,
          responsive: [
              {
                  breakpoint: 1024,
                  settings: {
                      slidesToShow: 5,
                      slidesToScroll: 1,
                      infinite: true,
                      dots: false
                  }
              },
              {
                  breakpoint: 600,
                  settings: {
                      slidesToShow: 4,
                      slidesToScroll: 1,
                      initialSlide: 2
                  }
              },
              {
                  breakpoint: 480,
                  settings: {
                      slidesToShow: 3,
                      slidesToScroll: 1
                  }
              }
          ]
      }; */
    /* const settings = {
        // dots: true,
        infinite: true,
        // slidesToShow: 3,
        // slidesToScroll: 1,
        autoplay: true,
        // speed: 2000,
        autoplaySpeed: 2500,
        cssEase: "linear",
        dots: false,
        infinite: true,
        speed: 800,
        slidesToShow: 8,
        slidesToScroll: 1,
        nextArrow: <CustomNextArrow />,
        prevArrow: <CustomPrevArrow />,
    }; */


    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 8,
        autoplay: true,
        slidesToScroll: 1,
        autoplaySpeed: 2000,
        cssEase: "linear",
        nextArrow: <CustomNextArrow />,
        prevArrow: <CustomPrevArrow />,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    initialSlide: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            }
        ]
    }; 

    useEffect(() => {

        AOS.init({
            disable: "phone",
            duration: 700,
            easing: "zoom-y-out",
          });
        }, [])
    return (
        <>
            <div className="slider-container" 
            data-aos="fade-up" data-aos-duration="1500" 
            data-aos-delay="200" 
            >
                <Slider {...settings}>
                    {genres.map((card, index) => (
                        <Link to={`/movies_by_genre/${card.genres_id != null ? card.genres_id : card.genres_id}`}>
                            <div>
                                <img
                                    style={{
                                        width: '100%',
                                        height: '100%',
                                        padding: '5%'
                                    }}
                                    src={card.genres_poster != null ? card.genres_poster : card.genres_poster} className="card-img-top slick-slider-img" />
                            </div>
                        </Link>
                    ))}
                </Slider>
            </div>
        </>
    )
}
export default Genres